import {getApi} from '../../modules/common/utils/api'

const api = getApi('default')

export function getGroups() {
  return api.get(`/v3/groups`)
}

export function getGroup({group_id, params = null}) {
  return api.get(`/v3/groups/${group_id}`, {
    params: params,
  })
}

export function getGroupFields({group_id}) {
  return api.get(`/v3/groups/${group_id}/fields`)
}

export function getGroupFieldValues({group_id, field_id}) {
  return api.get(`/v3/groups/${group_id}/fields/${field_id}/values`)
}

export function getGroupActions({group_id, params = {}}) {
  return api.get(`/v3/groups/${group_id}/actions`, {params})
}

export function getGroupActionFields({group_id, action_id, type = null, all_fields = false}) {
  return api.get(`/v3/groups/${group_id}/actions/${action_id}/fields`, {
    params: all_fields
      ? {type: type, all_field_attributes: all_fields, parent_child_relation: true}
      : {type: type, is_open_field: true},
  })
}

export function getGroupStatuses({group_id}) {
  return api.get(`/v3/groups/${group_id}/statuses`)
}

export function getGroupFilters({group_id, query = null, limit = null, type = null}) {
  return api.get(`/v3/groups/${group_id}/filters`, {
    params: {limit: limit, query: query, type: type},
  })
}

export function getAdditionalFieldValues(
  group_id,
  field_types,
  include_actions,
  include_related,
  currency_items
) {
  return api.post(`/v3/entities/${group_id}/field_types`, {
    include_actions: include_actions,
    include_related: include_related,
    field_types: field_types,
    currency_items: currency_items,
  })
}

export function getGroupFilterValues({
  group_id,
  field_id,
  query = null,
  limit = null,
  type = null,
}) {
  return api.get(`/v3/groups/${group_id}/filters`, {
    params: {field_id: field_id, limit: limit, query: query, type: type},
  })
}

export function searchGanttObjects(group_id, params = {}) {
  return api.post(`/v3/groups/${group_id}/objects/search_gantt_view`, params)
}

export function searchGroupObjects(group_id, params = {}) {
  return api.post(`/v3/groups/${group_id}/objects/search`, params)
}

export function getReservationCalenderObjects(group_id, params = {}) {
  return api.post(`/v3/groups/${group_id}/reservation_calender_objects`, params)
}

export function getReservationItems({group_ids = [], status, offset, limit, query}) {
  return api.get(`/v3/get_reservation_items`, {
    params: {group_ids: group_ids, limit: limit, offset: offset, status: status, query: query},
  })
}

export function putReservationApproveReject(data) {
  return api.put(`/v3/update_reservation_states`, data)
}

export function deleteReservation(data) {
  return api.delete(`/v3/delete_multiple_reservations`, {data})
}
